import { Decodable } from "./_decodable";

export class ProposalBillingItem extends Decodable {
    static readonly STATUS_PENDING = 'pending';
    static readonly STATUS_BILLED = 'billed';
    static readonly STATUS_PAID = 'paid';

    id?: number;
    proposalId?: number;
    type?: string;
    typeName?: string;
    installmentNumber?: number;
    description?: string;
    amount: number = 0;
    status?: string;
    statusName?: string;
    billedAt?: Date;
    paidAt?: Date;
    billedByCustomerId?: number;
    paidByCustomerId?: number;
    hasReceipt: boolean = false;
    receiptId?: number;
    canBill: boolean = false;
    canPay: boolean = false;
    createdAt?: Date;
    updatedAt?: Date;

    protected _map = {
        amount: (e) => Number(e),
        installmentNumber: (e) => Number(e),
        canBill: (e) => !!e,
        canPay: (e) => !!e,
        hasReceipt: (e) => !!e,
        receiptId: (e) => e ? Number(e) : null,
        billedAt: (e) => this.parseDate(e),
        paidAt: (e) => this.parseDate(e),
        createdAt: (e) => this.parseDate(e),
        updatedAt: (e) => this.parseDate(e),
    };
}
